import { FormGroup } from '@angular/forms';
import { AgencyLookupDetail } from '../../shared/models/agency-lookup-detail';
import { AgencyLookupStore } from '../../shared/lookup/agency-lookup/agency-lookup.store';
import { Party } from '../models/party';
import { PartyType } from '../models/party-type';

export class AgencyLookupConverter {

  static updateFormFields(detail: AgencyLookupDetail,
                          contactLookupForm: FormGroup,
                          agencyLookupStore: AgencyLookupStore) {

    contactLookupForm.patchValue({
      name: detail.name,
      dbaName: detail.dbaName,
      line1: detail.address.line1,
      line2: detail.address.line2,
      line3: detail.address.line3,
      countryCode: detail.address.countryCode,
      city: detail.address.city,
      state: detail.address.state,
      postalCode: detail.address.postalCode,
      agencyId: detail.agencyId
    });
    contactLookupForm.controls[ 'contact' ].patchValue({
      firstName: detail.contact.firstName,
      lastName: detail.contact.lastName,
      email: detail.contact.email,
      phone: detail.contact.phone,
      fax: detail.contact.fax
    });

    agencyLookupStore.clearSearchResults();
  }

  static agencyLookupDetailToParty(detail: AgencyLookupDetail): Party {
    return new Party({
      eventPartyId: null,
      version: null,
      createdDate: null,
      modifiedDate: null,
      brand: null,
      chain: null,
      propertyId: null,
      agencyId: detail.agencyId,
      partyType: PartyType.AGENCY,
      code: detail.agencyId,
      name: detail.name,
      dbaName: detail.dbaName,
      countryCode: detail.address.countryCode,
      eventId: null,
      line1: detail.address.line1,
      line2: detail.address.line2,
      line3: detail.address.line3,
      city: detail.address.city,
      state: detail.address.state,
      postalCode: detail.address.postalCode,
      eventReferenceNumber: null,
      autoGeneratedCode: detail.autoGeneratedCode,
      manuallyAdded: detail.manuallyAdded,
      contact: {
        eventContactId: null,
        version: null,
        createdDate: null,
        modifiedDate: null,
        partyType: PartyType.AGENCY,
        eventId: null,
        firstName: null,
        lastName: null,
        email: null,
        phone: null,
        fax: null
      }
    });
  }
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/utils/agency-lookup-converter.ts